
  import {Component} from 'vue-property-decorator';
  import {Getter} from 'vuex-class';

  import {mdiSvg, nameRoutes} from '@/core';

  import {BalanceAlertConfiguration} from '../interfaces/balance-alert-configuration/balance-alert-configuration';
  import BaseService from './BaseService.vue';

  @Component
  export default class BalanceAlertPopUp extends BaseService {
    @Getter('balanceAlertConfig', {namespace: 'site'})
    balanceAlertConfig!: BalanceAlertConfiguration;

    firstname = window.localStorage.getItem('firstname');

    lastname = window.localStorage.getItem('lastname');

    routes = nameRoutes;

    svgLibrairy = mdiSvg;

    alertMessage = '';

    mounted(): void {
      if (this.balanceAlertConfig.alertMessage) {
        this.alertMessage = this.balanceAlertConfig.alertMessage;
      }
    }

    rederectToTopUp(): void {
      this.$emit('closeModal');
      this.$router.push({
        name: this.routes.badge,
        params: {slug: this.$route.params.slug},
      });
    }
  }
